import { bigQuery } from '@fiverr-private/obs';
import { sendEvents } from '@fiverr-private/futile/lib/send/sendEvents';
import { getContext } from '@fiverr-private/fiverr_context';
import {
    BI_DOMAIN_MAPPING,
    BI_CONSTS
} from '../constants';
import { removeEmptyEntries } from '../utils';

const prepareBigQueryPayload = ({
    type,
    element,
    actionType,
    component,
    categoryId,
    isMobile,
    userGuid,
    organizationId,
    userId,
    pageCtxId,
    agencyBannerExists
}) => removeEmptyEntries({
    type,
    uid: userGuid,
    organization: {
        id: organizationId
    },
    user: {
        id: userId
    },
    platform: isMobile ? 'mobile_web' : 'web',
    group: BI_CONSTS.USER_ACTIONS,
    sub_group: 'website_actions',
    feature: {
        name: 'navigation_bar'
    },
    category: {
        id: categoryId
    },
    page: {
        element,
        component
    },
    action: {
        type: actionType
    },
    out_of_session: false,
    domain: {
        name: BI_DOMAIN_MAPPING[type] || BI_CONSTS.BUYERS
    },
    publisher: {
        domain: BI_CONSTS.BUYERS,
        sub_domain: BI_CONSTS.CATERPILLARS
    },
    context_id: pageCtxId,
    agency: {
        banner_exist: agencyBannerExists
    }
});

export const sendBigQueryEvent = (data) => {
    if (typeof Fiverr === 'object' && typeof Fiverr.sendClientEvents === 'function') {
        sendEvents(data);
    } else {
        bigQuery.send(data);
    }
};

export const trackBiEvent = (type, { item, actionType, trackingData, elementType, agencyBannerExists } = {}) => {
    const { reportData: { categoryId } } = item;
    const {
        isMobile = false,
        userGuid,
        organizationId,
        userId
    } = trackingData;
    const component = { name: trackingData.vertical, type: trackingData.context };
    const element = { name: trackingData.entry, type: elementType };
    const { pageCtxId } = getContext();

    sendBigQueryEvent(prepareBigQueryPayload({
        type,
        element,
        actionType,
        component,
        categoryId,
        isMobile,
        userGuid,
        organizationId,
        userId,
        pageCtxId,
        agencyBannerExists
    }));
};
